import { render, staticRenderFns } from "./SGoodsCate.vue?vue&type=template&id=7115b4ae&scoped=true"
import script from "./SGoodsCate.vue?vue&type=script&lang=js"
export * from "./SGoodsCate.vue?vue&type=script&lang=js"
import style0 from "./SGoodsCate.vue?vue&type=style&index=0&id=7115b4ae&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115b4ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7115b4ae')) {
      api.createRecord('7115b4ae', component.options)
    } else {
      api.reload('7115b4ae', component.options)
    }
    module.hot.accept("./SGoodsCate.vue?vue&type=template&id=7115b4ae&scoped=true", function () {
      api.rerender('7115b4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/modules/editor/modules/SGoodsCate.vue"
export default component.exports